import { render, staticRenderFns } from "./BestSellingsList.vue?vue&type=template&id=29caae96&lang=pug&"
import script from "./BestSellingsList.vue?vue&type=script&lang=js&"
export * from "./BestSellingsList.vue?vue&type=script&lang=js&"
import style0 from "./BestSellingsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports